const globals = {
  LINK_CADASTRO: 'https://credpago.com.br/cadastre-se',
  maxWidth: '1420px',
  paddingSides: {
    normal: '30px',
    small: '20px'
  },
  fonts: {
    sans: 'Roboto, sans-serif',
    serif: 'Georgia, serif',
    default: 'Roboto, sans-serif',
    headings: '"Uni Neue", Roboto, sans-serif',
  },
  colors: {
    lightblue: '#26c3ef',
    darkblue: '#113c64',
    red: '#ef5252',
    green: '#64a964',
    gray: '#6c6c6c'
  },
  mediaqueries: {
    darkmode: '(prefers-color-scheme: dark)',
    huge: 'screen and (min-width:1441px)',
    large: 'screen and (min-width: 1171px) and (max-width:1440px)',
    medium: 'screen and (min-width: 769px) and (max-width:1170px)',
    small: 'screen and (min-width: 451px) and (max-width:768px)',
    extraSmall: 'screen and (max-width:450px)',
    // caso seja adicionado mais media queries, 
    // também existem referencias à esses breakpoints
    // no arquivo src/grid/style.js
    // favor atualizar em ambos os lugares
  },
  headings: {
    h1: '45px',
    h2: '36px',
    h3: '22px',
    h4: '20px',
    h5: '18px',
    h6: '16px'
  },
  inputs: {
    lineHeight: {
      small: '35px',
      normal: '47px',
      large: '55px'
    },
    padding: {
      small: '0 10px',
      normal: '0 25px',
      large: '0 40px'
    }
  }
}

export default globals